<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
    <v-card class="elevation-11">
      <v-card-text>
        <span class="heading">
          <h2 class="mb-3 mr-3">{{pageHeading}}</h2>
          <div v-if="pageHeading==='Notes'" class="archived">
            <a href="#" @click="handleArchived">{{linkText}}</a>
          </div>
          <a href="#" @click="$router.push('/admin')" class="ml-3">admin >></a>
        </span>

        <div v-for="item in items" :key="item.id" class="item">
          <a :href=item.downloadURL target="_blank"><v-icon class="mr-2">file_download</v-icon></a>
           <p class="card-title mb-2" @click="editItem(item)">{{ item.title }}</p>
        </div>
      </v-card-text>
    </v-card>
    </v-flex>
  </v-layout>
</template>
 
<script>
import { mapState } from "vuex"
import { alphabetize, sortByDate } from '../../mixins/utilities.js'
export default {
  data() {
    return {
      linkText: "Show archived notes"
    }
  },
  computed: {
    ...mapState([
      "notes",
      "handouts",
      "tracks",
      "finalTracks",
      "type",
      "greetings",
      "user"
    ]),
    pageHeading() {
      return this.type;
    },
    items() {
      switch (this.pageHeading) {
        case "Notes":
        let arrNotes = alphabetize(this.notes, 'title')
        if(this.linkText === "Hide archived notes") {
          return arrNotes
        } else {
          return arrNotes.filter( el => {
            return el.archived === false
          })
        }
          break;
        case "Handouts":
          return alphabetize(this.handouts, 'title')
          break;
        case "Tracks":
          return alphabetize(this.tracks, 'title')
          break;
        case "Final Tracks":
          return alphabetize(this.finalTracks, 'title')
          break;
        case "Greetings":
          return sortByDate(this.greetings, 'dateEnd')
          break;

        default:
          break;
      }
    },
    strURL() {
      if (this.type !== "Greetings") {
        return "/editItem";
      } else {
        return "/editGreeting";
      }
    }
  },
  methods: {
    handleArchived() {
      this.linkText === "Hide archived notes" ? this.linkText = "Show archived notes" : this.linkText = "Hide archived notes"
    },
    editItem(item) {
      if (this.pageHeading === "Greetings") {
        this.$router.push({
          name: 'editGreeting',
          params: { item: item }
        });
      } else {
        this.$router.push({
          name: 'editItem',
          params: { item: item }
        });
      }
    }
  }
};
</script>

<style scoped>
.item {
  display: flex;
}

.heading{
  display: inline-flex;
  align-items: baseline;
}

p {
  margin: 5px;
  color: #3d3d3d;
  text-decoration: underline;
  cursor: pointer;
}
</style>